// extracted by mini-css-extract-plugin
export var block = "Link-module--block--f95f2";
export var flex = "Link-module--flex--fc6f0";
export var inline = "Link-module--inline--57b8f";
export var inlineBlock = "Link-module--inlineBlock--78614";
export var inlineFlex = "Link-module--inlineFlex--6da07";
export var light = "Link-module--light--b3eb7";
export var link = "Link-module--link--289e9";
export var none = "Link-module--none--097db";
export var paragraph = "Link-module--paragraph--7a7a2";
export var paragraphSm = "Link-module--paragraph-sm--e2781";
export var paragraphXs = "Link-module--paragraph-xs--3f9c6";
export var titleH1 = "Link-module--title-h1--876ef";
export var titleH1Alt = "Link-module--title-h1--alt--730ff";
export var titleH2 = "Link-module--title-h2--ae979";
export var titleH2Alt = "Link-module--title-h2--alt--0a6ce";
export var titleH3 = "Link-module--title-h3--c3015";
export var titleH3Alt = "Link-module--title-h3--alt--3aa77";
export var titleH4 = "Link-module--title-h4--e8b9b";
export var titleH4Alt = "Link-module--title-h4--alt--3c9af";
export var titleH5 = "Link-module--title-h5--4cfb4";
export var underline = "Link-module--underline--1a4b5";